/* eslint-disable import/prefer-default-export */
import config from '../api/constants'
import Config from 'custom/config/environment'
import * as CryptoJS from 'crypto-js'
import http from '../api/api'

const AES_SECRET_KEY = CryptoJS.enc.Utf8.parse(Config.NEO_KEY)
const encryptAES = (text) =>
  CryptoJS.AES.encrypt(text, AES_SECRET_KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString()

const changeUserPassword = async ({ oldPwd, newPwd }) => {
  try {
    const encryptedOldPwd = await encryptAES(oldPwd)
    const encryptedNewPwd = await encryptAES(newPwd)
    const reqParams = {
      oldPassword: encryptedOldPwd,
      newPassword: encryptedNewPwd,
      requestId: 'GETPROFILEIMAGE',
    }
    const response = await http.post(config.apiRoute.CHANGE_PWD_REQUEST, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const getNotificationDetails = async () => {
  try {
    const reqParams = {
      requestId: 'GETNOTIFICATIONS',
    }
    const response = await http.post(config.apiRoute.GET_CUST_NOTIFICATIONS, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const addAccountNickName = async ({ accountNumber, nickName }) => {
  try {
    const reqParams = {
      srcAccount: accountNumber,
      accountNickName: nickName,
      requestId: 'ACCOUNTNICKNAME',
    }
    const response = await http.post(config.apiRoute.ADD_NICK_NAME, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const SettingService = {
  changeUserPassword,
  getNotificationDetails,
  addAccountNickName
}

export default SettingService
